export default __webpack_public_path__ + "media/assets/fonts/roboto-slab-v13-latin-500-677ab222f95f446b2bbf6a2ea08da62b.woff2";